import apiService from '@/services/ApiService'
import Helper from '@/common/helper'

const api = new apiService()

export default {
    getCams({ commit }) {
        return new Promise((resolve, reject) => {
            api.getCams().then(cams => {
                commit('setCams', cams.filter(cam => cam.status.enabled))
                resolve()
            }, (e) => {
                reject(e)
            })
        })
    },
    getMaps({ commit }) {
        api.getMaps().then(maps => commit('setMaps', maps))
    },
    getMapImage({ commit, getters }, { mapGroupId, mapId, imageId }) {
        let data = {
            mapGroupId,
            mapId,
        }

        return new Promise((resolve, reject) => {
            api.getMapImage(mapGroupId, imageId).then(r => {
                Helper.preloadImage(r).then(image => {
                    commit('updateMap', {
                        ...data,
                        map: {
                            image: r,
                            width: image.width,
                            height: image.height,
                        }
                    })

                    resolve(r)
                })
            }, () => {
                commit('updateMap', {
                    ...data,
                    map: {
                        image: false,
                    }
                })

                reject()
            })
        })
    },
    getViews({ commit, state, getters }) {
        return new Promise((resolve, reject) => {
            api.getViews(state.user.login).then(views => {
                commit('setViews', views)
                let view = getters.getActiveView

                if (view)
                    commit('setGrid', view.grid)

                resolve(views)
            })
        })
    },
    getViewsData({ commit, state, getters }) {
        return new Promise((resolve, reject) => {
            api.getViews(state.user.login).then(views => {
                resolve(views)
            })
        })
    },
    saveView({ commit, state }, view) {
        return new Promise((resolve, reject) => {
            api.saveView(view, state.user.login).then(view => {
                commit('resetTempView')
                commit('saveView', view)
                resolve(view)
            }, () => {
                reject()
            })
        })
    },
    removeView({ commit, state }, viewId) {
        return new Promise((resolve, reject) => {
            api.removeView(viewId, state.user.login).then(viewId => {
                commit('removeView', viewId)
                resolve(viewId)
            }, () => {
                reject()
            })
        })
    },
    setGrid({ commit, state, getters}, grid) {
        let view = getters.getActiveView

        commit('setGrid', grid)

        if (view) {
            commit('changeViewGrid', {
                grid: grid,
                viewId: view.id
            })
        }
    },
    getCamImage({ commit, state }, camId) {
        let cam = state.cams.find(cam => cam.id == camId) || null

        if (cam) {
            cam.image = 'loading'

            api.getCamImage(cam.id).then(r => {
                cam.image = r
            }, () => {
                cam.image = false
            })
        }
    },
    getAlarms({ commit, state }, { cams, params }) {
        commit('setAlarms', [])

        return new Promise((resolve, reject) => {
            api.getAlarms(cams, params).then(alarms => {
                commit('setAlarms', alarms)
                resolve(alarms)
            }, () => {
                reject()
            })
        })
    },
    getPage({ commit, state }, name) {
        return new Promise((resolve, reject) => {
            api.getPage(name).then(r => {
                resolve(r)
            })
        })
    },
    getObject(store, { type, id }) {
        return api.getAcsObject(type, id)
    },
    async setWsWebConnect({ commit, dispatch, getters }) {
        try {
            const res = await api.get('ws_auth')
            const wsWebConnect = new WebSocket(`ws://${window.location.host}/ws/`)
            commit('setWsWebConnect', wsWebConnect)
            wsWebConnect.onmessage = res => {
                const data = res.data ? JSON.parse(res.data) : null
                if (data) {
                switch(data.type) {
                    case 'state':
                    commit('setObjectState', {
                        data: data.data,
                        getters
                    })
                    break;
                }
                }
            }
            wsWebConnect.onclose = () => {
                dispatch('setWsWebConnect')
            }
            await new Promise((resolve, reject) => {
                wsWebConnect.onopen = () => {
                resolve(this)
                }
                wsWebConnect.onerror = err => {
                reject(err)
                }
            })
            wsWebConnect.send(JSON.stringify({
                type: "auth",
                token: res.token
            }))
        } catch(e) {
            console.log('e', e)
            dispatch('setWsWebConnect')
        }
      }
}



// WEBPACK FOOTER //
// ./src/store/actions.js